import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './mcbookie.features';
import { themeColors } from './mcbookie.config';
import { McbookieLogotype } from './mcbookie.logotype';
import { McBookieLogo } from 'src/layouts/LoginPage/logos/McBookieLogo';
import McBookieLoginImage from 'src/layouts/LoginPage/loginBgImages/McBookieLoginImage.jpg';
import { McBookieBrandIconWrapper } from './mcbookie.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'McBookie Backoffice',
    urls: {
        website: 'https://www.mcbookie.com/',
        backoffice: 'https://mcbookie-backoffice.sherbetcloud.com/',
    },
    BrandIcon: () => <McBookieBrandIconWrapper />,
    Logotype: () => <McbookieLogotype />,
    LogotypeLoginPage: () => <McBookieLogo />,
    compliancePopupLogo: null,
    loginImageContainer: () => <LoginImageWrapper imgSrc={McBookieLoginImage} />,
};
